import React from 'react'
import Box from '../box'

export default ({ children }) => (
  <Box p={[0,5]} borderRadius={[0,2]} boxShadow={[0,1]} bg="blanco" style={{transition: `all .5s ease`}} className="panel">
    {children}
  </Box>
);